<template>
  <div>
      <b-modal size="sm"
               ref="modal"
               id="modal-1"
               title="Estiva de Carga"
               @show="onReset"
               @hidden="onReset"
               @ok="handleOk">

        <b-alert class="text-center" v-if="selected_row != null" show ><h3>Pallet: {{selected_row.number}}</h3></b-alert>
  
        <b-form-group label="Peso Bruto del Pallet">
          <b-form-input
            type="text"
            :state="$v.form.gross_weight.$dirty ? !$v.form.gross_weight.$error : null"
            v-model="$v.form.gross_weight.$model"
            v-on:keyup = "inputSoloNumeroDecimal"
            placeholder="Peso Bruto">
          </b-form-input>
        </b-form-group>
        <b-form-group label="Temperatura">
          <b-form-input
            type="text"
            :state="$v.form.temperature.$dirty ? !$v.form.temperature.$error : null"
            v-model="$v.form.temperature.$model"
            placeholder="Temperatura">
          </b-form-input>
        </b-form-group>
        <b-form-group label="Posición">
          <b-form-select v-model="$v.form.position.$model"
                         :state="$v.form.position.$dirty ? !$v.form.position.$error : null"
                         :options="position_options"></b-form-select>
        </b-form-group>
        <b-form-group label="Termógrafo">
          <b-form-input
            type="text"
            :state="$v.form.temperature_recorder.$dirty ? !$v.form.temperature_recorder.$error : null"
            v-model="$v.form.temperature_recorder.$model"

            placeholder="Termografo">
          </b-form-input>
        </b-form-group>
      </b-modal>
  </div>
</template>

<script>
  import {required, numeric, decimal} from 'vuelidate/lib/validators'
  import {mapState, mapActions, mapGetters} from 'vuex';

  export default {
    name: "modalPalletExport",
    data() {
      return {
        show: true,
        form: {
          temperature: null,
          temperature_recorder: null,
          position: null,
          gross_weight: null,
        },
        selected_row: null,
        position_options: [
          {value: 1, text: 1},
          {value: 2, text: 2},
          {value: 3, text: 3},
          {value: 4, text: 4},
          {value: 5, text: 5},
          {value: 6, text: 6},
          {value: 7, text: 7},
          {value: 8, text: 8},
          {value: 9, text: 9},
          {value: 10, text: 10},
          {value: 11, text: 11},
          {value: 12, text: 12},
          {value: 13, text: 13},
          {value: 14, text: 14},
          {value: 15, text: 15},
          {value: 16, text: 16},
          {value: 17, text: 17},
          {value: 18, text: 18},
          {value: 19, text: 19},
          {value: 20, text: 20},
        ]
      }
    },
    computed: {
      ...mapGetters('socketModule', ['selectedScale']),
      ...mapState('socketModule', ['socketWeight', 'connected']),
    },
    validations: {
      form: {
        gross_weight: {decimal},
        temperature: {decimal},
        position: {numeric},
        temperature_recorder: {},
      }
    },
      watch: {
     socketWeight(newValue, oldValue) {
      //console.log(`Updating from ${oldValue} to ${newValue}`);
      this.form.gross_weight=newValue;
     }
     
    },
    methods: {
      handleOk(bvModalEvt) {
        
        // Prevent modal from closing
        bvModalEvt.preventDefault();
        // Trigger submit handler
        this.onSubmit()
      },
      onSubmit() {
        this.$v.form.$touch()
        if (this.$v.form.$anyError) {
          return
        }


        var rowNew = {
            gross_weight:this.form.gross_weight,
            position:this.form.position,
            temperature: this.form.temperature,
            temperature_recorder:this.form.temperature_recorder

        };
      
        // Form submit logic
        this.selected_row.export_info = rowNew;
        this.$emit("submitModal", this.selected_row);
        this.$nextTick(() => {
          this.$refs.modal.hide();
          this.$v.form.$reset();
        })
      },
      onReset(evt) {
        // Reset our form values
        this.form.position = null;
        this.form.temperature_recorder = null;
        this.form.temperature = null;
        this.form.gross_weight = null;
        this.$v.form.$reset();
 
      },
       inputSoloNumeroDecimal(event) {

     event.target.value = event.target.value.replace(/[^0-9.]/, '');

    },
    }
  }
</script>

<style scoped>

</style>
